
export const isLegacyItem = (item) => item.result === "legacy order";
